import React from 'react';
import ReactDOM from 'react-dom';
import {LauncherAppComponent} from './components/launcher-app/launcher-app.component';
import {LauncherServiceFactory} from './services/launcher-service-factory';
import {LauncherContextProvider} from './launcher.context';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import {blue} from '@material-ui/core/colors';
import {LocationService} from "../app-react/services/location/location.service";
import {ILoggerService} from '../app-react/services/logger/logger.service.interface';
import {IStorageService} from '../app-react/services/storage/storage.service.interface';



function createTheme() {
    return createMuiTheme({
        palette: {
            primary: blue
        }
    });
}

function initHybridForIOS() {
    const theWebkit: any = window['webkit'];
    if(theWebkit && theWebkit.messageHandlers && theWebkit.messageHandlers.cbCallBackHandlerCGP){

        let json = '{"splash":"1","service":"WebView","fn":"WebShow","cb":"hybridCallback13"}';
        theWebkit.messageHandlers.cbCallBackHandlerCGP.postMessage(json);

    }
}

function initHybridForAndroid() {
    let json = '{"splash":"1","service":"WebView","fn":"WebShow","cb":"hybridCallback17"}';

    if(window['WrapperInterfaceCGP'] && window['WrapperInterfaceCGP']['cbCallBackHandlerCGP']){

        window['WrapperInterfaceCGP']['cbCallBackHandlerCGP'](json);
    }
}

export function startLauncher(locationService: LocationService, storage: IStorageService, logger: ILoggerService) {

    window.addEventListener("DOMContentLoaded", () => {
        initHybridForIOS();
        initHybridForAndroid();
    });

    const theme = createTheme();

    ReactDOM.render(
        (
            <ThemeProvider theme={theme}>
                <LauncherContextProvider value={{services: new LauncherServiceFactory(locationService, storage, logger)}}>
                    <LauncherAppComponent />
                </LauncherContextProvider>
            </ThemeProvider>),
        document.getElementById('launcher-app-container'));
}

